import { api } from '../client';

export interface PageParams {
  page?: number;
  size?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
  [key: string]: unknown;
}

/**
 * Every module in the backend exposes the same shape, so the client for one is
 * generated rather than retyped. `updateMethod` covers the modules that use
 * PATCH (users) instead of PUT.
 */
export function createResourceApi<TResponse, TRequest, TParams extends PageParams = PageParams>(
  path: string,
  options: { updateMethod?: 'put' | 'patch' } = {},
) {
  const update = options.updateMethod ?? 'put';
  return {
    path,
    list: (params?: TParams) =>
      api.get<import('@/types/api').Paginated<TResponse>>(path, { params }),
    get: (id: string) => api.get<TResponse>(`${path}/${id}`),
    create: (body: TRequest) => api.post<TResponse>(path, body),
    update: (id: string, body: TRequest) =>
      update === 'put' ? api.put<TResponse>(`${path}/${id}`, body) : api.patch<TResponse>(`${path}/${id}`, body),
    remove: (id: string) => api.delete<void>(`${path}/${id}`),
  };
}
